// Site-wide structured-data builders for JSON-LD (schema.org)
const SITE_URL = 'https://residentialsupport.co.uk';

const LOGO_URL = `${SITE_URL}/logo512.png`; // CRA default; brand asset

export const organizationLd = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  '@id': `${SITE_URL}/#organization`,
  name: 'Residential Support Ltd',
  legalName: 'Agents Support Ltd T/A Residential Support',
  url: SITE_URL,
  logo: LOGO_URL,
  description:
    'Outsourcing partner for UK letting agents — check-in and check-out inventories, accompanied viewings, and professional photography paired with floor plans, delivered by one trusted team.',
  address: {
    '@type': 'PostalAddress',
    streetAddress: '20 Allandale Road',
    addressLocality: 'Leicester',
    postalCode: 'LE2 2DA',
    addressCountry: 'GB',
  },
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: '+44-3333-445336',
    contactType: 'customer service',
    email: 'info@residentialsupport.co.uk',
    areaServed: 'GB',
    availableLanguage: ['en-GB'],
  },
  identifier: '1624825', // UK company number
};

export const websiteLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  '@id': `${SITE_URL}/#website`,
  url: SITE_URL,
  name: 'Residential Support',
  publisher: { '@id': `${SITE_URL}/#organization` },
  inLanguage: 'en-GB',
};

export const localBusinessLd = {
  '@context': 'https://schema.org',
  '@type': 'ProfessionalService',
  '@id': `${SITE_URL}/#business`,
  name: 'Residential Support Ltd',
  url: SITE_URL,
  image: LOGO_URL,
  telephone: '+44-3333-445336',
  email: 'info@residentialsupport.co.uk',
  priceRange: '££',
  address: {
    '@type': 'PostalAddress',
    streetAddress: '20 Allandale Road',
    addressLocality: 'Leicester',
    postalCode: 'LE2 2DA',
    addressCountry: 'GB',
  },
  areaServed: { '@type': 'Country', name: 'United Kingdom' },
  openingHoursSpecification: [
    {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
      opens: '09:00',
      closes: '17:00',
    },
  ],
};

// Helper: build a BreadcrumbList from an array of {label, path?} items.
export const buildBreadcrumbLd = (items) => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: items.map((it, i) => ({
    '@type': 'ListItem',
    position: i + 1,
    name: it.label,
    item: it.path ? `${SITE_URL}${it.path}` : undefined,
  })),
});

export const SITE = { url: SITE_URL };
